export default {
  meta: {
    title: '品牌库',
  }
};
